import React from 'react'
import { BrowserRouter as Router, Switch as Routes , Route } from 'react-router-dom'
// import pages
import Home from './pages/Home'
import About from './pages/About'
import SingleCocktail from './pages/SingleCocktail'
import Error from './pages/Error'
import Navbar from './components/Navbar';
// import components

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/about">
          <About />
        </Route>
        <Route path="/cocktail/:id">
          <SingleCocktail />
        </Route>
        <Route path="*">
          <Error />
        </Route>
      </Routes>
    </Router>
  );
}

export default App
